// Strict name match. Previously this also regexed on the error message
// (`/reject|cancel/i`) which silently swallowed any server error whose text
// happened to contain "cancelled". If a future TonConnect SDK renames
// `UserRejectsError`, we prefer a visible error toast over a silent swallow.
export const isUserRejectedError = (err: unknown): boolean => {
  if (typeof err !== "object" || err === null) return false
  const name = (err as { name?: unknown }).name
  return name === "UserRejectsError"
}
